import y2011 from './2011.json';
import y2012 from './2012.json';
import y2013 from './2013.json';
import y2014 from './2014.json';
import y2015 from './2015.json';
import y2016 from './2016.json';
import y2017 from './2017.json';
import y2018 from './2018.json';
import y2019 from './2019.json';
import y2020 from './2020.json';
import y2021 from './2021.json';
import y2022 from './2022.json';
import y2023 from './2023.json';
import y2024 from './2024.json';

const json = {
    id: 'denver',
    coordinates: [278, 208],
    full_name: 'Denver',
    short_name: 'Denver',
    chart_data: [y2011, y2012, y2013, y2014, y2015, y2016, y2017, y2018, y2019, y2020, y2021, y2022, y2023, y2024],
};

export default json;
